// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stop-watch {
  font-size: x-large;
  justify-content: center;
  align-items: center;
  border: solid;
  border-width: 1px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.384);
  height: 33px;
  width: 80px;
}

.stop-watch.small {
  font-size: large;
  justify-content: center;
  align-items: center;
  border: solid;
  border-width: 1px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.384);
  height: 25px;
  width: 50px;
}

.stop-watch-heading {
  font-size: xx-small;
  font-weight: 900;
}

.stop-watch-container { 
  margin-top: 1px;
  font-family: 'Raleway';
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: xx-large;
}

.stop-watch-container.small { 
  font-size: large;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsiePreview/NewsieBottomBar/Stopwatch/Stopwatch.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".stop-watch {\n  font-size: x-large;\n  justify-content: center;\n  align-items: center;\n  border: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  background-color: rgba(255, 255, 255, 0.384);\n  height: 33px;\n  width: 80px;\n}\n\n.stop-watch.small {\n  font-size: large;\n  justify-content: center;\n  align-items: center;\n  border: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  background-color: rgba(255, 255, 255, 0.384);\n  height: 25px;\n  width: 50px;\n}\n\n.stop-watch-heading {\n  font-size: xx-small;\n  font-weight: 900;\n}\n\n.stop-watch-container { \n  margin-top: 1px;\n  font-family: 'Raleway';\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: xx-large;\n}\n\n.stop-watch-container.small { \n  font-size: large;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
